export const unwrapPayload = payload => {
  if (!payload || typeof payload !== 'object') return payload;
  if (payload.data !== undefined) return unwrapPayload(payload.data);
  if (payload.Data !== undefined) return unwrapPayload(payload.Data);
  return payload;
};

export const unwrapListItems = payload => {
  const data = unwrapPayload(payload);
  if (!data) return [];
  if (Array.isArray(data.items)) return data.items;
  if (Array.isArray(data.Items)) return data.Items;
  if (Array.isArray(data)) return data;
  return [];
};

export const unwrapApiItems = payload => {
  const candidates = [
    payload?.data?.items,
    payload?.data?.Items,
    payload?.data?.data,
    payload?.data?.Data,
    payload?.Data?.Items,
    payload?.items,
    payload?.Items,
    Array.isArray(payload?.data) ? payload.data : null,
    Array.isArray(payload) ? payload : null,
  ];
  const items = candidates.find(Array.isArray);
  return items ?? [];
};

export const unwrapApiData = result => result?.data ?? result;
